import { render, staticRenderFns } from "./PressReleaseEdit.vue?vue&type=template&id=28a50144&scoped=true"
import script from "./PressReleaseEdit.vue?vue&type=script&lang=js"
export * from "./PressReleaseEdit.vue?vue&type=script&lang=js"
import style0 from "./PressReleaseEdit.vue?vue&type=style&index=0&id=28a50144&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a50144",
  null
  
)

export default component.exports